'use strict';

iceSafeApply.$inject = ['$rootScope'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceSafeApply;
/*@ngInject*/
function iceSafeApply($rootScope) {
  return function (fn, $scope) {
    $scope = $scope || $rootScope;
    var phase = $scope.$root.$$phase;
    if (phase == '$apply' || phase == '$digest') {
      if (fn) {
        $scope.$eval(fn);
      }
    } else {
      if (fn) {
        $scope.$apply(fn);
      } else {
        $scope.$apply();
      }
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/iceSafeApply.js
// module id = 132
// module chunks = 2